import { Box, CircularProgress } from '@mui/material';
import type { FC } from 'react';

interface LoadingProps {
  size?: string | number | undefined;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
}

const Loading: FC<LoadingProps> = ({ size, color }) => (
  <Box display="flex" width="100%" alignItems="center" justifyContent="center">
    <CircularProgress size={size ?? 40} color={color ?? 'primary'} />
  </Box>
);

export default Loading;
